import { Box } from '@gemini/core';
import { isGermanPortal } from '@mfe-helpers/portalHelpers';
import { useAppContext } from '@mfe-presentation/contexts';
import { formatTextInputValue } from '@mfe-helpers/format';
import { EUIComponent } from '@mfe-types/enum';
import { TStyleProps } from '@mfe-types/box';
import FieldsetWrapper from '@mfe-presentation/components/Wrappers/FieldsetWrapper';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

import FieldWrapper from '../Wrappers/FieldWrapper';

const phoneNumberContainerStyles: TStyleProps = {
    display: 'flex',
    flexDirection: 'row',
};

const phoneNumberRegionCodeStyles: TStyleProps = {
    marginRight: 'spacing.8',
    width: '105px',
};

const phoneNumberStyles: TStyleProps = {
    maxWidth: 'calc(100% - 105px - 8px)',
};

const PhoneNumberVerificationForm = () => {
    const {
        formValues,
        config,
        currentStep: { name },
    } = useAppContext();

    const { t } = useTranslation(NAME_SPACE);

    return (
        <Box as="form" display="flex" flexDirection="column">
            <FieldsetWrapper
                name="phoneInformation"
                legendTitle={t(`step_${name}.modal.fieldsets.phoneInformation.legend`)}
                styles={phoneNumberContainerStyles}
            >
                <FieldWrapper
                    name="phoneNumberRegionCode"
                    styles={phoneNumberRegionCodeStyles}
                    field={{
                        uiComponent: EUIComponent.Select,
                        formatInputValue: formatTextInputValue,
                        isRequired: false,
                        defaultValue: formValues.phoneNumberRegionCode,
                        options: {
                            values: config.identity.getFields(formValues).phoneNumberRegionCode
                                .options.values,
                        },
                        autocomplete: 'tel-country-code',
                    }}
                />
                <FieldWrapper
                    name="phoneNumber"
                    styles={phoneNumberStyles}
                    field={{
                        uiComponent: EUIComponent.TextField,
                        formatInputValue: formatTextInputValue,
                        isRequired: true,
                        isRequiredHidden: true,
                        defaultValue: '',
                        inputMode: 'tel',
                        type: 'tel',
                        autocomplete: 'tel-national',
                        validators: config.identity.getFields(formValues).phoneNumber.validators,
                    }}
                />
            </FieldsetWrapper>
        </Box>
    );
};

export default PhoneNumberVerificationForm;
